import React from "react";
import { useSelector } from "react-redux";
import { Button } from "shared/Button";

import styles from "./ContinueBlock.module.scss";

const ContinueBlock = ({ onClick }) => {
  const { contactDetails, shippingAddress } = useSelector((s) => s.checkout);

  const isDisabled = !Boolean(contactDetails && shippingAddress);

  return (
    <div className="gkit-d-flex gkit-justify-end">
      <Button
        className={styles.action}
        disabled={isDisabled}
        onClick={onClick}
        size="lg"
      >
        Continue to payment
      </Button>
    </div>
  );
};

export default ContinueBlock;
